module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cn":{"updateData":"更新数据"},"en":{"updateData":"Update Data"}}')
  delete Component.options._Ctor
}
